import clsx from "clsx"
import { useEffect, useId } from "react"
import { useSupportedPaymentMethods } from "src/checkout/components/stages/paymentForm/useSupportedPaymentMethods"
import { useExpressCheckoutState } from "src/checkout/state/checkoutExpressStore"
import { NpErrorMessage } from "src/components/np-design/components/NpErrorMessage"
import { loadAndRenderPayPalButton } from "src/integrations/paypal/load"
import { genericErrorMessage } from "src/utilities/errorMessages"

const enabled = process.env.NEXT_PUBLIC_PAYPAL_CHECKOUT_ENABLED === "true"
const hasClientId = !!process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID

export const CheckoutWithPayPalButton = () => {
  const { errorMessage } = useExpressCheckoutState()
  const supportedPaymentMethods = useSupportedPaymentMethods()
  const id = useId()

  const supported = enabled && hasClientId && supportedPaymentMethods.includes("paypal")
  const failed = !!errorMessage

  useEffect(() => {
    if (supported) {
      void loadAndRenderPayPalButton(id)
    }
  }, [supported, id])

  return (
    <div
      className={clsx("mx-auto flex w-full flex-col gap-2 text-center", {
        // Avoid "Document is ready and element #paypal-js-sdk does not exist" by always mounting the element.
        absolute: !supported,
      })}
    >
      <div id={id} className="flex" />
      {failed ? <NpErrorMessage message={errorMessage || genericErrorMessage} /> : null}
    </div>
  )
}
